import { ExtraOptions, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { ExportInquiryDataGuard } from './guards/export-inquiry-data.guard';
import { RotationGuard } from './guards/rotation.guard';

export const routingConfiguration: ExtraOptions = {
    paramsInheritanceStrategy: 'always',
    onSameUrlNavigation: 'reload',
};

export const routeConfig: Routes = [
    {
        path: 'error',
        loadComponent: () =>
            import('./components/system-error/system-error.component').then((m) => m.SystemErrorComponent),
        data: {
            pageTitle: 'Error',
        },
    },

    {
        path: '',
        loadComponent: () => import('./components/home/home.component').then((m) => m.HomeComponent),
        data: {
            pageTitle: 'Lettings Application',
        },
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./components/dashboard/dashboard.component').then((m) => m.DashboardComponent),
                data: {
                    pageTitle: 'dashboard',
                },
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('@components/dashboard/sections/adverts/adverts.component').then(
                                (m) => m.AdvertsComponent,
                            ),
                    },
                ],
            },
            {
                path: 'rotation',
                loadComponent: () =>
                    import('@components/rotation/rotation-teaser/rotation-teaser.component').then(
                        (m) => m.RotationTeaserComponent,
                    ),
                canActivate: [RotationGuard],
                data: {
                    pageTitle: 'rotation',
                },
            },
            {
                path: 'export-inquiry-data',
                loadComponent: () =>
                    import('@components/export-inquiry-data/export-inquiry-data.component').then(
                        (m) => m.ExportInquiryDataComponent,
                    ),
                canActivate: [ExportInquiryDataGuard],
                data: {
                    pageTitle: 'export inquiry data',
                },
            },
            {
                path: 'teasers',
                loadComponent: () =>
                    import('./components/teaser-list/teaser-list.component').then((m) => m.TeaserListComponent),
                data: {
                    pageTitle: 'teasers list',
                },
            },
            {
                path: 'advert/:unitId',
                loadComponent: () => import('./components/advert/advert.component').then((m) => m.AdvertComponent),
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('./components/advert-details/advert-details.component').then(
                                (m) => m.AdvertDetailsComponent,
                            ),
                        data: {
                            pageTitle: 'advert details',
                        },
                    },
                    {
                        path: 'history',
                        loadComponent: () =>
                            import('./components/advert-event-history/advert-event-history.component').then(
                                (m) => m.AdvertEventHistoryComponent,
                            ),
                        data: {
                            pageTitle: 'event history',
                        },
                    },
                    {
                        path: 'prospects',
                        loadComponent: () =>
                            import('./components/advert-prospects/advert-prospects.component').then(
                                (m) => m.AdvertProspectsComponent,
                            ),
                        runGuardsAndResolvers: 'always',
                        data: {
                            pageTitle: 'prospects',
                        },
                    },
                    {
                        path: 'general-inquiries',
                        loadComponent: () =>
                            import('@components/advert-general-inquiries/advert-general-inquiries.component').then(
                                (m) => m.AdvertGeneralInquiriesComponent,
                            ),
                    },
                    // TODO: to change the path, we have to adjust the route inside ics file which is generated by BE
                    {
                        path: 'events',
                        redirectTo: 'viewings',
                        data: {
                            pageTitle: 'events',
                        },
                    },
                    {
                        path: 'viewings',
                        loadComponent: () =>
                            import('./components/advert-viewings/advert-viewings.component').then(
                                (m) => m.AdvertViewingsComponent,
                            ),
                        data: {
                            pageTitle: 'viewings',
                        },
                    },
                ],
            },
            {
                path: ':unitId/image-upload',
                loadComponent: () =>
                    import('@components/advert-image-upload/advert-image-upload.component').then(
                        (m) => m.AdvertImageUploadComponent,
                    ),
                data: {
                    pageTitle: 'upload images',
                },
            },
            {
                path: 'preview/:unitId',
                loadComponent: () =>
                    import('./components/advert-preview/advert-preview.component').then(
                        (m) => m.AdvertPreviewComponent,
                    ),
                data: {
                    pageTitle: 'preview advert',
                },
            },
            {
                path: '404',
                loadComponent: () =>
                    import('./components/not-found/not-found.component').then((m) => m.NotFoundComponent),
                data: {
                    pageTitle: 'Not found',
                },
            },
            {
                path: '**',
                loadComponent: () =>
                    import('./components/not-found/not-found.component').then((m) => m.NotFoundComponent),
                data: {
                    pageTitle: 'Not found',
                },
            },
        ],
    },
];
